<template>
  <div>
    <v-alert v-model="editOvenAlert" dismissible type="error">{{ editOvenAlertMessage }}</v-alert>

    <v-form v-on:submit.prevent="save()">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('settings.ovenAddEdit.titleEdit') }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field :label="$t('settings.ovenAddEdit.name')" v-validate="'required|min:3'" data-vv-name="name"
                  :error-messages="errors.collect('name')" required v-model="ovenEdited.name"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="black" flat large @click="$emit('close'); resetAll()">{{ $t('global.cancel') }}</v-btn>

          <!--
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            flat
            large
            @click="confirmRemoveDialog = true"
          >{{ $t('settings.ovenAddEdit.remove') }}</v-btn>
          -->

          <v-spacer></v-spacer>

          <v-btn color="green darken-1" flat large @click="save()">{{ $t('global.save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>

    <!-- Dialog de confirmation de suppression -->
    <v-dialog v-model="confirmRemoveDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{ $t('settings.ovenAddEdit.removeConfirmTitle') }}</v-card-title>
        <v-card-text>{{ $t('settings.ovenAddEdit.removeConfirmMessage') }}</v-card-text>
        <v-card-actions>
          <v-layout row wrap>
            <v-flex xs6>
              <v-btn block color="black" flat @click="confirmRemoveDialog = false">{{ $t('global.no') }}</v-btn>
            </v-flex>
            <v-flex xs6>
              <v-btn color="red darken-1" flat block @click="confirmRemoveDialog = false; removeOven()">{{
                $t('global.yes')
              }}</v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>



<script>
export default {
  props: ["oven"],
  data: () => ({
    confirmRemoveDialog: false,
    editOvenAlert: false,
    editOvenAlertMessage: null,
    ovenEdited: {
      name: null,
      key: null
    }
  }),
  computed: {},
  watch: {
    oven() {
      this.resetAll();
      if (this.oven) {
        this.ovenEdited.name = this.oven.name;
        this.ovenEdited.key = this.oven.key;
      }
    }
  },
  methods: {
    // reset tout
    resetAll() {
      // reset validation
      this.$validator.reset();
      // reset le formulaire et l'alerte
      this.ovenEdited.name = null;
      this.ovenEdited.id = null;
      this.ovenEdited.key = null;
      //
      this.editOvenAlert = false;
      this.editOvenAlertMessage = null;
    },
    // supprime un four
    removeOven() {
      // requete
      this.api
        .delete("/client/ovens/" + this.oven.id)
        .then(res => {
          // reset
          this.resetAll();
          // fermeture de la dialog
          this.$emit("close");
          this.$store.dispatch("removeOven", this.oven.id);
          // recharge la liste
          return this.$store.dispatch("loadOvenList");
        })
        .catch(err => {
          console.log(err);
        });
    },

    // enregistre les modifications
    async save() {
      // check les données
      var result = await this.$validator.validate();

      if (!result) {
        // impossible de valider !
        return;
      }

      // requete
      this.api
        .patch("/ovens/" + this.oven.id, {
          name: this.ovenEdited.name
        })
        .then(res => {
          // reset
          this.resetAll();
          // fermeture de la dialog
          this.$emit("close");
          // recharge la liste
          return this.$store.dispatch("loadOvenList");
        })
        .catch(err => {
          console.log(err);
        });
    },

    // reset tout
    resetAll() {
      // reset validation
      this.$validator.reset();
      // reset le formulaire et l'alerte
      this.ovenEdited.name = null;
      this.ovenEdited.id = null;
      this.ovenEdited.key = null;
    }
  },
  mounted() { }
};
</script>

<style>

</style>


